export default __webpack_public_path__ + "assets/cookie_consent_icon.9e93bc5babdacce5702f7c86d0309c85.svg";